import type { ColumnType } from 'antd/lib/table';
import { TFunction } from 'i18next';
import { CONFIG } from 'src/config';

export const dateColumn = <T extends { date: string }>(t: TFunction): ColumnType<T> => ({
  title: t('Date'),
  dataIndex: 'date',
  render: (_, item) => new Date(item.date).toLocaleDateString(CONFIG.LOCALE),
});
